import { Injectable, inject } from '@angular/core';
import AngularHelperService from '../services/angular-helper.service';
import $ from 'jquery';

@Injectable({ providedIn: 'root' })
export default class Browser {
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	
	getScrollbarWidth() {
		var outer: any = document.createElement('div');
		outer.style.visibility = 'hidden';
		outer.style.pointerEvents = 'none';
		outer.style.width = '100px';
		outer.style.msOverflowStyle = 'scrollbar';
		
		document.body.appendChild(outer);
		
		var widthNoScroll: any = outer.offsetWidth;
		outer.style.overflow = 'scroll';
		
		var inner: any = document.createElement('div');
		inner.style.width = '100%';
		outer.appendChild(inner);
		
		var widthWithScroll: any = inner.offsetWidth;
		
		outer.parentNode.removeChild(outer);
		
		return widthNoScroll - widthWithScroll;
	}
	
	getBrowser() {
		var userAgent: any = this.angularHelperService.getWindow().navigator.userAgent;
		var browsers: any = {
			chrome: /\bChrome\b/.test(userAgent) || /\bCriOS\b/.test(userAgent),
			firefox: /\Firefox\b/.test(userAgent),
			edge: /\Edge\b/.test(userAgent),
			safari: /^((?!CriOS).)*\Safari\b.*$/.test(userAgent),
			opera: /\Opera\b/.test(userAgent),
			ie: /\bMSIE\b/.test(userAgent) || /\Trident\b/.test(userAgent)
		};
		
		if (userAgent.toLowerCase().indexOf('android') > -1) return 'android';
		if (this.detectIE()) return 'ie';
		
		return browsers.ie ? 'ie' :
		(browsers.edge ? 'edge' :
		(browsers.opera ? 'opera' :
		(browsers.chrome ? 'chrome' :
		(browsers.firefox ? 'firefox' :
		(browsers.safari ? 'safari' : 'unknown')))));
	}
	
	detectIE() {
		var ua: any = window.navigator.userAgent;
		
		var msie: any = ua.indexOf('MSIE ');
		if (msie > 0) {
			return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
		}
		
		var trident: any = ua.indexOf('Trident/');
		if (trident > 0) {
			var rv: any = ua.indexOf('rv:');
			return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
		}
		
		return false;
	}
	
	getClientIp() {
		$.getJSON('https://jsonip.appspot.com', function(data) {
			return data.ip;
		}, function(data) {
			$.getJSON('http://jsonip.com/', function(data) {
				return data.ip;
			}, function(data) {
				return null;
			});
		});
	}
	
	isMobileBrowser() {
		if (/mobile/i.test(navigator.userAgent)) {
			return true;
		}
		return false;
	}
	
	isMobileView() {
		$(window).resize(() => {
			var w: any = $(window).width();
			return w ? w <= 480 : false;
		});
	}
	
	pageLoaded(callback) {
		var everythingLoaded: any = setInterval(() => {
			if (/loaded|complete/.test(document.readyState)) {
				clearInterval(everythingLoaded);
				callback();
			}
		}, 10);
	}
	
}